export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0023s_0000_Black-&-White-13.d9abe000.png";